import {defineStore} from "pinia";
import {ref, Ref} from "vue";
import {ISmartSearchFilterInterface, ISmartSearchResult} from "@/features/search/search.types";
import {searchService} from "@/features/search/search.service";

export const useSearchStore = defineStore("search", () => {
    const smartSearchFilter = ref<ISmartSearchFilterInterface>({
        q: '',
        types: 'messages,calls,chats,errors',
        account_id: null,
        chat_id: null,
        time_from: null,
        time_to: null,
        limit_per_type: 3,
        fuzzy: true,
        fuzzy_threshold: 0.3
    })

    const smartSearchData = ref<ISmartSearchResult>()

    async function smartSearch(
        loading: Ref<boolean>,
        signal?: AbortSignal
    ) {
        try {
            loading.value = true
            await searchService.smartSearch(smartSearchFilter.value, signal).then((result) => {
                smartSearchData.value = result.data.results
            })
        } finally {
            loading.value = false
        }
    }

    return {
        smartSearchFilter,
        smartSearchData,
        smartSearch,
    };
});
